import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { OrdersCoServices } from '../../services';

/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-table-notes',
  templateUrl: 'orders-table-notes.html',
})
export class OrdersTableNotesPage {

  order: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    public ordersCoServices: OrdersCoServices, ) {
    this.getOrder();
    this.getTableNotes();
  }

  ionViewDidLoad() {

  }

  async getTableNotes() {
    //Recuperamos el comentario de la mesa
    await this.ordersCoServices.firestore.collection('tables').doc(this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID).get().then(doc => {
      this.ordersCoServices.customer_note = doc.data().notes;
    });
  }

  save() {
    //Actualizamos el comentario de mesa y de order
    this.ordersCoServices.afs.collection('tables').doc(this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID).update({
      'notes': this.ordersCoServices.customer_note,
    }).then(async doc => {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('takeaway-order-note-comentario-guardado'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    });

    if (this.order != undefined) {
      this.ordersCoServices.afs.collection('orders').doc(this.order.UID).update({
        'notes': this.ordersCoServices.customer_note,
      });
    }

  }

  async getOrder() {
    //Recuperamos la order
    await this.ordersCoServices.getOrders(this.globals.restaurant_uid, this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID);
    this.ordersCoServices.orders.subscribe(doc => {
      this.order = doc[0];
      if (this.order == undefined) {
        this.order = '';
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-table/orders-table-notes/orders-table-notes.ts